import axios from 'axios';

const state = {
    data: [],
    select: [],
    orderables: [{
            title: 'Nome',
            name: 'name'
        },
        {
            title: 'Cadastrado em',
            name: 'created_at'
        }
    ],
    filterGroups: [{
        name: 'Device',
        filters: [{
                title: 'Nome',
                name: 'name',
                type: 'string'
            },
            {
                title: 'Cadastrado em',
                name: 'created_at',
                type: 'datetime'
            }
        ]
    }]
};

const mutations = {
    SET_DEVICE: (state, payload) => {
        state.data = payload;
    },
    SET_DEVICE_SELECT: (state, payload) => {
        state.select = payload;
    },
};

const actions = {
    setDevices: (context, payload) => {
        context.commit('SET_DEVICE', payload);
    },
    setDevicesDeleted: (context, payload) => {
        context.commit('SET_DEVICE_DELETED', payload);
    },
    storeDevice: (context, payload) => {
        let promise = new Promise((resolve, reject) => {
            axios.post('/api/device/store', payload)
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response.data);
                });
        });
        return promise;
    },
    updateDevice: (context, payload) => {
        let promise = new Promise((resolve, reject) => {
            axios.put(`/api/device/${payload.uuid}/update`, payload).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
        return promise;
    },
    getDeviceById: (context, payload) => {
        return axios.get(`/api/device/${payload}/details`).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    },
    getDeviceQrcode: (context, payload) => {
        let promise = new Promise((resolve, reject) => {
            axios.get(`/api/device/${payload}/qrcode`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        });
        return promise;
    },
    getDeviceStatus: (context, payload) => {
        let promise = new Promise((resolve, reject) => {
            axios.get(`/api/device/${payload}/status`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        });
        return promise;
    },
    getDeviceMessages: (context, payload) => {
        let promise = new Promise((resolve, reject) => {
            axios.get(`/api/device/${payload}/messages`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        });
        return promise;
    },
    getChatMessages: (context, payload) => {
        let promise = new Promise((resolve, reject) => {
            axios.get(`/api/device/${payload.device}/message/${payload.chatId}`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        });
        return promise;
    },
    disconectDevice: (context, payload) => {
        let promise = new Promise((resolve, reject) => {
            axios.delete(`/api/device/${payload}/session`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        });
        return promise;
    },
};
export default {
    state,
    mutations,
    actions
};